import { render, staticRenderFns } from "./formgroup.vue?vue&type=template&id=b22973e2&"
import script from "./formgroup.js?vue&type=script&lang=js&"
export * from "./formgroup.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22973e2')) {
      api.createRecord('b22973e2', component.options)
    } else {
      api.reload('b22973e2', component.options)
    }
    module.hot.accept("./formgroup.vue?vue&type=template&id=b22973e2&", function () {
      api.rerender('b22973e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/formgroup.vue"
export default component.exports